module.exports = __webpack_public_path__ + "static/bg-lifesync-909f6751161d8351f23fd2a15077017a.webp";